import type { AccountRecord } from '@libs/data-access/entities'
import { msToMinute, timeBetween } from '@spa/utils/time'
import getPlannedBreakDuration from 'snap-redux/modules/shifts/utils/breaks/getPlannedBreakDuration'
import getRealBreakDuration from 'snap-redux/modules/shifts/utils/breaks/getRealBreakDuration'

import type { RestModel } from '../../../../../redux/models/Rest'
import type { ShiftModel } from '../../../../../redux/models/Shift'

type Props = {
  shift: ShiftModel
  rest: RestModel
  account: AccountRecord
}

// Returns the shift duration in minutes
export const getShiftDuration = ({ account, shift, rest }: Props) => {
  // If account preference `paid_breaks` is disabled
  // We deduct total break duration from shift duration
  const deductBreaks = !account.paid_breaks

  // If shift owner did not show and the shift has a rest
  // we display the planned hours over real one.
  if (shift.did_not_show && !!rest) {
    // minute
    const restDuration = msToMinute(
      timeBetween(new Date(rest.starts_at), new Date(rest.ends_at))
    )

    // minute
    const breakDuration = getPlannedBreakDuration(shift.shift_breaks)
    return Math.abs(restDuration) - (!deductBreaks ? 0 : breakDuration)
  }

  // minute
  const shiftDuration = msToMinute(
    timeBetween(new Date(shift.real_starts_at), new Date(shift.real_ends_at))
  )
  // minute
  const breakDuration = getRealBreakDuration(shift.shift_breaks)
  return Math.abs(shiftDuration) - (!deductBreaks ? 0 : breakDuration)
}
